import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import types, { storeName } from './types';

const setVerificationState = createAction(types.SET_VERIFICATION_STATE);
const setShareEmailId = createAction(types.SET_SHARE_EMAIL_ID);

export default {
    ...dynaForms.getActions(storeName),
    setVerificationState,
    setShareEmailId,
};
